// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aebbizttaazznfwwadzb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlYmJpenR0YWF6em5md3dhZHpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxOTE2NDEsImV4cCI6MjA4ODc2NzY0MX0.SfCi90QfkJLvkyuaOEqnMQLkAHsv5POqNHdKZ79YlhE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});